import { useState, useCallback, ReactNode, useRef } from 'react';

import styles from './knmLateFieldsLinks.module.scss';

export interface IKnmLateFieldsLinksProps {
  className?: string;
  content: ReactNode;
}

export const KnmLateFieldsLinks = ({ className, content }: IKnmLateFieldsLinksProps) => {
  const iconRef = useRef<HTMLSpanElement>(null);

  const { x, y, width, height } = iconRef.current?.getBoundingClientRect() || {};

  const [isVisible, setIsVisible] = useState(false);

  const handleIconClick = useCallback(() => setIsVisible(prev => !prev), []);

  if (!content) {
    return null;
  }

  const getTopSize = () => {
    if (y || height) {
      return Number(y) + Number(height) / 2;
    }
  };

  const getRightSize = () => {
    if (x || width) {
      return Number(x) + Number(width) + 11;
    }
  };

  const tooltipAttributes = {
    ...(isVisible && { 'data-visible': true }),
  };

  return (
    <div className={className ? `${styles.Container} ${className}` : styles.Container}>
      <span className={styles.Icon} onClick={handleIconClick} />
      {isVisible && (
        <div className={styles.Tooltip} {...tooltipAttributes}>
          <div
            style={{
              top: getTopSize(),
              left: getRightSize(),
            }}
          >
            {content}
          </div>
        </div>
      )}
    </div>
  );
};
